import src from "IMAGE";
export default { src, width: 216, height: 91, blurWidth: 0, blurHeight: 0};
